export const profileSyncWorkExperience = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncWorkExperience.html',
    bindings: {
        diff: '<',
        onApply: '&',
        onCancel: '&',
    },
};
